/** 함우리몰 — 브랜드명과 경로를 한 곳에서 관리한다. */
export const MALL_NAME = '함우리몰'

/** 결제 후 상품을 받기까지 최장 기간. 상품 상세·배송 정책에 같이 적는다. */
export const MALL_FULFILLMENT_LIMIT = '결제 후 14일 이내'

/** 쇼핑몰 (몰 전용 레이아웃) */
export const MALL_HOME_PATH = '/mall'
export const MALL_CART_PATH = '/mall/cart'
export const MALL_CHECKOUT_PATH = '/mall/checkout'
/** 공개 배송조회 (로그인 불필요) */
export const MALL_TRACKING_PATH = '/mall/tracking'
/** 쿠팡형 마이쇼핑 허브 */
export const MALL_MYPAGE_PATH = '/mall/mypage'
export const MALL_ORDERS_PATH = '/mall/mypage/orders'
export const MALL_SHIPPING_PATH = '/mall/mypage/shipping'
export const MALL_WISHLIST_PATH = '/mall/mypage/wishlist'
export const MALL_STORE_PATH = '/mall/store'

export function mallProductPath(id: string): string {
  return `${MALL_HOME_PATH}/${id}`
}

export function mallStorePath(sellerCode: string): string {
  return `${MALL_STORE_PATH}/${encodeURIComponent(sellerCode)}`
}
